export default __webpack_public_path__ + "static/media/swipe360.848887b1.png";